<template>

    <el-container class="layout-container">
        <!-- 顶部导航 -->
        <el-header class="app-header">
            <!-- 平台名：与主布局 pages/index.vue 保持一致，Header2 自身不含 logo，此处补渲染 -->
            <div class="app-logo">{{ platformName }}</div>
            <Header2 @reset-password="showResetPassword" @change="handleNavChange" />
        </el-header>


        <!-- 主内容区 -->
        <el-main class="app-main">
            <div class="cont">
                <overlay-scrollbars style="width: 100%;height: 100%;" class="el-fade-in">
                    <div class="d-flex" style="position: absolute;left: 0;top: 0;width: 100%;height: 100%;">
                        <div class="flex-1 position-relative">
                            <router-view v-slot="{ Component }">
                                <transition name="slide-fade">
                                    <component :is="Component" />
                                </transition>
                            </router-view>
                        </div>


                    </div>
                </overlay-scrollbars>
            </div>
        </el-main>
        <!-- 密码重置弹窗 -->
        <ResetPassword :show="modal1" @on-close="modal1 = false" />
        <!-- 教学反思弹窗 -->
        <ReflectEditor :show="showReflectEditor" :showBtns="showReflectBtns" :content="reflectContent"
            :returns="reflectAnalysisResult" @on-cancel="handleReflectCancel" @on-submit="handleReflectSubmit" />
    </el-container>

</template>

<script>
import Header2 from '@/components/Header2.vue'
import ResetPassword from '../ResetPassword.vue';
import ReflectEditor from './comp/ReflectEdit.vue';
import { mapMutations } from 'vuex'
import { create, get } from '@/request/api/reflect.js'
export default {
    components: {
        ResetPassword,
        Header2,
        ReflectEditor
    },
    data() {
        return {
            modal1: false,
            showReflectEditor: false,
            showReflectBtns: false,
            reflectContent: '',
            reflectAnalysisResult: '',
            currentLessonId: '',
            currentTeacherId: ''
        }
    },
    computed: {
        platformName() {
            return (typeof window !== 'undefined' && window.mconfig && (window.mconfig.name || window.mconfig.nav_title)) || '智慧教研平台'
        }
    },
    mounted() {
        // 初始化时直接从当前路由获取参数
        this.currentLessonId = this.$route.query.lesson_id || '';
        this.currentTeacherId = this.$route.query.teacher_id || '';

        // 监听路由变化，实时更新课程ID和教师ID
        this.$router.afterEach((to) => {
            this.currentLessonId = to.query.lesson_id || '';
            this.currentTeacherId = to.query.teacher_id || '';
        });
        this.handleReflectGet();
    },
    methods: {
        ...mapMutations(['logout']),
        showResetPassword() {
            this.modal1 = true
        },
        // 处理导航栏变化
        handleNavChange(handlerName) {
            if (handlerName === 'reflect') {
                this.showReflectEditor = true;
                // 只有当当前用户是课程教师时才显示提交按钮
                // 使用toString()确保类型一致，避免隐式类型转换问题
                const teacherId = String(this.currentTeacherId || '');
                const userId = String(this.$store.state.user?.id || '');
                this.showReflectBtns = teacherId === userId && teacherId !== '';
            }
        },
        // 处理反思弹窗取消
        handleReflectCancel() {
            this.showReflectEditor = false;
        },
        // 处理反思提交
        handleReflectSubmit(data) {
            const form = {
                content: data.html,
                formatContent: data.text,
                lessonId: this.currentLessonId
            };

            create(form).then(res => {
                this.showReflectEditor = false;
                if (res.code != 0) return this.$notify.error({ title: '错误', message: res.msg });
                this.$notify({ title: '成功', message: res.msg, type: 'success' });
            })
        },
        handleReflectGet() {
            get(this.currentLessonId).then(res => {
                if (res.data !== null) {
                    this.reflectContent = res.data.content;
                    this.reflectAnalysisResult = res.data.analysisResult;
                }
            })
        }
    }
}
</script>

<style scoped lang="less">
@header-height: 72px; // 顶部高度

@bg_color: #f5f7f9; //背景颜色
@top_bg-color: #ffffff; //顶部导航背景颜色
@sider_w: 200px; //侧边导航宽度
@sider_bg-color: #191A23; //侧边导航背景颜色


/deep/ .el-pagination.is-background .el-pager li {
    height: 32px;
    width: 32px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    background-color: transparent;
    font-weight: 400;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: transparent;
    border-color: #2d8cf0;
    color: #2d8cf0;
}

/deep/ .el-pagination.is-background .btn-prev,
/deep/ .el-pagination.is-background .btn-next {
    background-color: transparent;
    width: 32px;
    height: 32px;
    border: 1px solid #dcdee2;
    border-radius: 4px;
    font-weight: 400;
}

/deep/ .el-pagination .el-select .el-input {
    width: 80px;
}

/deep/ .el-input--mini .el-input__inner {
    height: 32px;
    border-radius: 4px;
}


// el-upload
/deep/ .el-upload {
    display: block;
}

/deep/ .el-upload-dragger {
    width: 100%;
}

// transition 过渡
.slide-fade-enter-active {
    transition: all .8s ease;
}

// .fade-leave-active {
//     transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
// }
.slide-fade-enter,
.slide-fade-leave-to {
    transform: translateX(50px);
    opacity: 0;
}

// 头部样式
.app-header {
    height: @header-height !important;
    background: transparent;
    padding: 0 20px;
    line-height: @header-height;
    position: relative;
}

// 顶栏左侧平台名，样式对齐主布局 pages/index.vue 的 .app-logo
.app-logo {
    position: absolute;
    left: 1.4%;
    top: 3.6vh;
    transform: translateY(-50%);
    z-index: 10;
    pointer-events: none;
    white-space: nowrap;
    line-height: 1;
    font-size: 2.3vw; // 44 / 1920，与原背景图烙印字号一致
    font-weight: 600;
    letter-spacing: 0.65em;
    color: #f2f9ff;
    text-shadow: 0 0 14px rgba(64, 156, 255, 0.55);
}

// 布局容器样式
.layout-container {
    height: 100%;
    width: 100%;
    min-height: 100vh;
    background-image: url('../../assets/home/background.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-attachment: fixed;
    background-color: #f5f7f9; // 添加背景色作为图片无法覆盖区域的填充色
}



// 主体容器样式
.main-container {
    flex: 1;
    display: flex;
    min-height: 0;
    // margin-top: 10px;
    /* 防止flex子元素溢出 */
}


// 主内容区样式
.app-main {
    flex: 1;
    padding: 0 20px;
    // padding: 20px;
    background: transparent;
    overflow: hidden;
    min-height: 0;
    /* 防止flex子元素溢出 */

    .cont {
        height: 100%;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;
        scrollbar-width: thin;
        scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
    }
}
</style>
